<template>
  <div>
    <SysBtn class="d-flex align-center" @click="dialog_ativo = !dialog_ativo">
      <v-icon size="18">mdi-chart-ppf</v-icon>
      <v-icon size="12" class="ml-n2 mt-n3">mdi-check</v-icon>
      <span class="ml-1">Aplicar coberturas</span>
      <span v-if="existe_agendamento" class="ml-1 font-12 text-gray-800">(agendado)</span>
    </SysBtn>

    <v-dialog v-model="dialog_ativo" width="450" content-class="bra-20" persistent transition="dialog-top-transition">
      <v-card class="px-3 overflow-hidden">
        <v-card-title class="py-4 pr-2 pl-1">
          <span class="font-18 ml-1">Aplicar cobertura</span>
          <v-spacer />
          <v-btn :disabled="etapa === 2" icon small @click="dialog_ativo = !dialog_ativo">
            <v-icon size="22">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-3 text-center">
          <div v-if="etapa === 1 && !existe_agendamento">
            <p class="ma-0 text-justify">
              <v-icon size="17" class="mr-n3" color="warning">mdi-alert-octagon-outline</v-icon>
              Aplicar as coberturas parametrizadas é influenciar diretamente a
              <strong>quantidade a ser comprada na tela de compras</strong>.
            </p>

            <p class="ma-0 mt-2 text-justify">
              Essa ação pode <strong>demorar e deixar o sistema lento</strong>, por isso esse processo é feito à noite.
            </p>
          </div>

          <div v-else-if="etapa === 2">
            <v-progress-circular v-if="etapa === 2" color="red" indeterminate size="40" class="my-4" />
            <p class="ma-0 text-center">Carregando... aguarde.</p>
          </div>

          <p v-else class="ma-0 text-center font-16 py-3">
            Agendamento realizado com sucesso, as coberturas serão aplicadas hoje à noite.
          </p>
        </v-card-text>

        <div class="d-flex align-center pb-3">
          <v-spacer />
          <v-btn
            v-if="etapa === 1 && !existe_agendamento"
            small color="#0d4663" dark
            @click="aplicarCoberturas"
          >
            <v-icon class="mr-1" size="17">mdi-clock-outline</v-icon>
            agendar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {agendarAplicacaoCoberturasCurvas, buscarExistenciaDeCoberturasAgendadas} from "@/api/Diagnostico/CurvasCruzadas";
import {logout} from "@/helpers";

export default {
  name: "AplicarCoberturas",
  props: {
    coberturas_mudou_count: Number
  },
  data: () => ({
    dialog_ativo: false,
    etapa: 1,
    existe_agendamento: false
  }),
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  watch: {
    dialog_ativo() {
      if (!this.dialog_ativo) {
        setTimeout(() => this.etapa = 1, 1000);
      }
    },
    coberturas_mudou_count() {
      this.buscarExistenciaAgendamento();
    }
  },
  created() {
    this.buscarExistenciaAgendamento();
  },
  methods: {
    buscarExistenciaAgendamento() {
      this.$store.dispatch('loading/addRequisicao',
        buscarExistenciaDeCoberturasAgendadas()
          .then(existe => this.existe_agendamento = existe)
          .catch(logout)
      );
    },
    aplicarCoberturas() {
      this.etapa = 2
      const parametros = {
        idgrupo: this.GRUPO_COMPRA
      }
      agendarAplicacaoCoberturasCurvas(parametros).then(() => {
        this.etapa = 3;
        this.buscarExistenciaAgendamento();
      }).catch(logout)
    }
  }
}
</script>

<style scoped>
</style>
